import { Helmet } from "react-helmet";
import Layout from "../../components/Layout/Layout";
import React, { useState, SyntheticEvent } from "react";
import Alert from "../../components/Alert/Alert";

const IndexPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const sendEmailFailedMsg =
    "Request failed to send. We have logged the error. Please try again later if you have not heard from us in 24 hours.";

  const handleSubmit = (e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    window.grecaptcha.ready(async function () {
      const token = await window.grecaptcha.execute(
        "6LfBup8eAAAAAFf4MYxd86xLlOMdbDL3h2kGZXQW",
        { action: "submit" }
      );
      const body = {
        from: {
          name: name,
          email: email,
        },
        message: message,
        token: token,
      };
      try {
        const request = await fetch(
          "https://integrativewellness-contact.matt7067.workers.dev",
          {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (request.status === 202) {
          setShowAlert(true);
          setSuccess(true);
          setError(false);
          setErrorMessage("");
        } else {
          const text = await request.text();
          setShowAlert(true);
          setSuccess(false);
          setError(true);
          setErrorMessage(text);
        }
      } catch (error) {
        setShowAlert(true);
        setSuccess(false);
        setError(true);
        setErrorMessage(sendEmailFailedMsg);
      }
    });
  };

  return (
    <Layout full={true} removeTopSpace={true} className="bg-yellow-50">
      <Helmet title="Contact" defer={false}>
        <script
          async
          src="https://www.google.com/recaptcha/api.js?render=6LfBup8eAAAAAFf4MYxd86xLlOMdbDL3h2kGZXQW"
        ></script>
      </Helmet>
      {showAlert && error ? (
        <Alert
          success={false}
          message={errorMessage}
          onDismiss={() => setShowAlert(false)}
        />
      ) : (
        ""
      )}
      {showAlert && success ? (
        <Alert
          success={true}
          message="Message sent!"
          onDismiss={() => setShowAlert(false)}
        />
      ) : (
        ""
      )}
      <section className="relative bg-yellow-50">
        <div className="absolute inset-x-0 top-0 h-96 bg-gradient-to-b from-green-100 via-green-100 to-yellow-50" />
        <div className="relative mx-auto max-w-5xl px-6 py-16 lg:px-8 lg:py-24">
          <div className="rounded-3xl bg-white p-6 shadow-lg md:p-10">
            <p className="text-sm font-bold uppercase tracking-wide text-green-900">
              Get in touch
            </p>
            <h1 className="mt-2 font-serif text-4xl font-bold leading-tight text-gray-900 md:text-5xl">
              Contact Integrative Wellness
            </h1>
            <div className="mt-6 grid gap-6 md:grid-cols-2">
              <div className="rounded-3xl bg-yellow-50 p-6 shadow">
                <p className="text-sm font-bold uppercase tracking-wide text-green-900">
                  Office
                </p>
                <a
                  href="https://www.google.com/maps/dir//5010+S+Broadband+Ln,+Sioux+Falls,+SD+57108"
                  className="mt-2 block leading-relaxed text-gray-700 hover:text-green-900"
                >
                  5010 S Broadband LN Ste 100,
                  <br />
                  Sioux Falls, SD 57108
                </a>
              </div>
              <div className="rounded-3xl bg-green-100 p-6 shadow">
                <p className="text-sm font-bold uppercase tracking-wide text-green-900">
                  Phone &amp; Fax
                </p>
                <p className="mt-2 leading-relaxed text-gray-700">
                  <a
                    href="tel:1-605-271-1348"
                    className="font-semibold text-green-900 hover:text-green-700"
                  >
                    Phone: 605.271.1348
                  </a>
                  <br />
                  <span>Fax: 605-610-1477</span>
                </p>
              </div>
            </div>
            <div className="mt-12">
              <form
                onSubmit={(e) => handleSubmit(e)}
                action="#"
                method="POST"
                className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8"
              >
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-bold uppercase tracking-wide text-green-900"
                  >
                    Name
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      autoComplete="given-name"
                      className="block w-full rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm focus:border-green-500 focus:ring-green-500"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <label
                    htmlFor="email"
                    className="block text-sm font-bold uppercase tracking-wide text-green-900"
                  >
                    Email
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      className="block w-full rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm focus:border-green-500 focus:ring-green-500"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <label
                    htmlFor="message"
                    className="block text-sm font-bold uppercase tracking-wide text-green-900"
                  >
                    Message
                  </label>
                  <div className="mt-2">
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      className="block w-full rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm focus:border-green-500 focus:ring-green-500"
                      defaultValue={""}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <button
                    type="submit"
                    disabled={showAlert}
                    className={`inline-flex w-full items-center justify-center rounded-full bg-green-900 px-7 py-4 text-base font-bold text-white shadow-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ${
                      showAlert
                        ? "cursor-not-allowed opacity-50"
                        : "cursor-pointer opacity-100 hover:bg-green-800"
                    }`}
                    onClick={(e) => handleSubmit(e)}
                  >
                    Let's talk
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndexPage;

export interface ContactRequest {
  from: Contact;
  message: string;
}

export interface Contact {
  name: string;
  email: string;
}
